
import React from 'react';
import { Helmet } from 'react-helmet-async';

import SubHeader from '../components/SubHeader';
import ServiceList from '../components/ServiceList';
import WhyChooseUs from '../components/WhyChooseUs';
import OurSkills from '../components/OurSkills';

const Services = () => {
  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Interior Decorators in Nagpur | ERA Interio",
    "description":
      "Explore interior design solutions in Nagpur for stylish, functional homes, bedrooms, kitchens and commercial spaces.",
    "image":
      "https://www.erainterio.com/static/media/eraintrerio-01.619cace3e540999f3bf5.png",
    "@id": "https://www.erainterio.com/services#professionalservice",
    "url": "https://www.erainterio.com/services",
    "telephone": "+91-8830219839",
    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "Shop No.2, 1st Floor, Shyama Apartment, Pratap Nagar Square, Pratap Nagar",
      "addressLocality": "Nagpur",
      "addressRegion": "Maharashtra",
      "postalCode": "440022",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 21.1130412,
      "longitude": 79.0561782
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "10:00",
        "closes": "19:00"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/erainterio9/",
      "http://www.facebook.com/erainterior9",
      "https://www.youtube.com/@eraintero"
    ]
  };

  return (
    <>
      <Helmet>
        {/* SEO Title */}
        <title>
          Interior Decorators in Nagpur – Services for Every Home | ERA Interio
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Looking for interior decorators in Nagpur? We style kitchens, bedrooms and living rooms to match your taste. Explore our services."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Interior Decorators in Nagpur, 3D Interior Design, Interior Services Nagpur, Interior Design Solutions, Interior Bedroom Design, Bedroom Design"
        />

        {/* Robots */}
        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.erainterio.com/services"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Your Dream Space Starts Here | Premium Interior Design Services | ERA Interio"
        />

        <meta
          property="og:description"
          content="Looking to transform your space? ERA Interio offers creative interior design services for homes, bedrooms, offices and commercial spaces—combining stylish designs, smart planning and functional solutions."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.erainterio.com/services"
        />

        <meta
          property="og:image"
          content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
        />

        <meta
          property="og:site_name"
          content="ERA Interio"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Your Dream Space Starts Here | Premium Interior Design Services | ERA Interio"
        />

        <meta
          name="twitter:description"
          content="Looking to transform your space? ERA Interio offers creative interior design services for homes, bedrooms, offices and commercial spaces—combining stylish designs, smart planning and functional solutions."
        />

        <meta
          name="twitter:image"
          content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(servicesSchema)}
        </script>
      </Helmet>

      <SubHeader
        seoTitle="See Your Home Before We Build It: 3D Designs by Interior Decorators in Nagpur"
      />

      <ServiceList />

      <WhyChooseUs />

      <OurSkills />
    </>
  );
};

export default Services;
